import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Invoice} from "../invoice";
import {InvoiceService} from "../invoice-service.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Customer} from "../customer";
import {CustomerService} from "../customer-service.service";

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {

  invoices: Invoice[];
  id: string;
  customerId: string;
  customer: Customer;
  customerPresent: string;
  action: string;
  myError: string;

  constructor(private invoiceService: InvoiceService,
              private activatedRoute: ActivatedRoute,
              private customerService: CustomerService,
              private router: Router) {
    this.myError = "";
  }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.action = this.activatedRoute.snapshot.params['action'];
    this.customerPresent = "0";

    if (this.action.localeCompare("show") == 0) {
      if (this.customerId.localeCompare("0") == 0) {
        this.invoiceService.findAll().subscribe(data => this.invoices = data, error => this.myError= "Invoices not found");
      } else {
        this.invoiceService.findAllByCustomerId(this.customerId).subscribe(data => {
          this.invoices = data;
          this.customerService.findById(this.customerId).subscribe( data => {
            this.customerPresent = "1";
            this.customer = data;
          }, error => this.myError= "Customer not found")
        }, error => this.myError= "Invoice not found");
      }
    }
    if (this.action.localeCompare("delete") == 0) {
      this.invoiceService.delete(this.id).subscribe(result => this.gotoInvoiceList(), error => this.myError= "Invoice deletion is not confirmed");
    }
    if (this.action.localeCompare("pay") == 0) {
      this.invoiceService.pay(this.id).subscribe(result => this.gotoInvoiceList(), error => this.myError= "Invoice payment is not confirmed");
    }
  }

  gotoInvoiceList() {
    this.router.navigate(['/invoices/show/' + this.customerId + "/0"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/invoice-list/invoice-list.component.ts